// extracted by mini-css-extract-plugin
export default {"form-button":"FormButton_form-button__6wrRx"};